import React from 'react';

import { Tr } from '@chakra-ui/react';

import CompositionGroupTable from './CompositionGroupTable';
import { formatCurrency, formatQuantity } from './formatters';
import { StyledTd, StyledTh } from './StyledTableCell';

export type MaterialGroupRow = {
  code: string;
  description: string;
  quantity: number;
  unit: string;
  unitPrice: number;
  unitCost: number;
};

type MaterialGroupTableProps = {
  data: MaterialGroupRow[];
};

const MaterialGroupTable: React.FC<MaterialGroupTableProps> = ({ data }) => {
  const totalMaterialUnitCost = data.reduce(
    (total, item) => total + item.unitCost,
    0,
  );

  return (
    <CompositionGroupTable
      headerRows={
        <Tr>
          <StyledTh colSpan={2}>C - MATERIAL</StyledTh>
          <StyledTh textAlign="center" width="90px">
            Quantidade
          </StyledTh>
          <StyledTh textAlign="center" width="90px">
            Unidade
          </StyledTh>
          <StyledTh textAlign="right" width="140px">
            Preço Unitário
          </StyledTh>
          <StyledTh textAlign="right" width="140px">
            Custo Unitário
          </StyledTh>
        </Tr>
      }
      bodyRows={
        <>
          {data.map((item) => (
            <Tr key={item.code}>
              <StyledTd width="1%" minWidth="50px" whiteSpace="nowrap">
                {item.code}
              </StyledTd>
              <StyledTd
                minWidth="220px"
                whiteSpace="normal"
                overflowWrap="break-word"
                wordBreak="break-word"
              >
                {item.description}
              </StyledTd>
              <StyledTd textAlign="center">
                {formatQuantity(item.quantity)}
              </StyledTd>
              <StyledTd textAlign="center">{item.unit}</StyledTd>
              <StyledTd textAlign="right">
                {formatCurrency(item.unitPrice)}
              </StyledTd>
              <StyledTd textAlign="right">
                {formatCurrency(item.unitCost)}
              </StyledTd>
            </Tr>
          ))}

          <Tr>
            <StyledTd colSpan={5} textAlign="right" fontWeight="600">
              Custo unitário total de material
            </StyledTd>
            <StyledTd textAlign="right" fontWeight="600">
              {formatCurrency(totalMaterialUnitCost)}
            </StyledTd>
          </Tr>
        </>
      }
    />
  );
};

export default MaterialGroupTable;
